export const mergeTwoObjects = (first, second) => {
  for (const key of Object.keys(first)) {
    if (Object.prototype.hasOwnProperty.call(second, key)) {
      if (typeof first[key] === 'object' && !Array.isArray(first[key]) && first[key] !== null) {
        mergeTwoObjects(first[key], second[key]);
      }
      first[key] = second[key];
    }
  }
};
